export default "__VITE_ASSET__CQj2O5$c__"